import * as Dialog from '@radix-ui/react-dialog';
import {
  type ForwardedRef,
  forwardRef,
  type HTMLAttributes,
  type ReactNode,
} from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';

export interface ModalDialogCloseProps
  extends Omit<
    Dialog.DialogCloseProps & ComponentProps<HTMLAttributes<HTMLButtonElement>>,
    'className'
  > {
  children: ReactNode;
}

export const ModalDialogClose = forwardRef<
  HTMLButtonElement,
  ModalDialogCloseProps
>(
  (
    { children, ...props }: ModalDialogCloseProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const className = getClassNameOverride(props, 'ModalDialog.Close');

    return (
      <Dialog.Close ref={ref} {...props} className={className} asChild>
        {children}
      </Dialog.Close>
    );
  },
);

ModalDialogClose.displayName = 'ModalDialog.Close';
